import styled from 'styled-components';

import breakpoints from '@r1-frontend/ui-kit/themes/breakpoints';

export const Logo = styled.div`
    display: block;
    margin: auto 17px auto 0;

    @media (max-width: ${breakpoints.mobile}) {
        margin-right: 10px;
    }

    @media (max-width: ${breakpoints.sMobile}) {
        margin-right: 7px;
    }
`;
